import { reducer as authReducer, MOUNT_POINT as AUTH_MOUNT_POINT } from './auth';

const reducers = {
    [AUTH_MOUNT_POINT]: authReducer,
};

export default reducers;
